<template>
  <el-card class="customized-gift-review">
    <h2 class="title-biaoti">定制礼物审核</h2>
    
    <!-- 查询条件 -->
    <div class="user-options">
      用户RID:
      <el-input v-model="queryParams.rid" style="width: 160px" clearable placeholder="请输入用户RID"></el-input>
      
      审核状态:
      <el-select v-model="queryParams.reviewStatus" style="width: 160px" clearable placeholder="请选择审核状态">
        <el-option v-for="item in reviewStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      
      申请时间:
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="timestamp"
        @change="onDateRangeChange">
      </el-date-picker>
      
      <el-button type="warning" @click="queryList" :loading="loading">
        查询
      </el-button>
      <el-button type="success" @click="batchReview" :disabled="selectedRows.length === 0">
        批量审核
      </el-button>
    </div>

    <!-- 表格 -->
    <el-table 
      :data="tableData" 
      style="width: 100%" 
      v-loading="loading" 
      border
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      
      <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
      
      <el-table-column prop="uid" label="用户UID" align="center" width="120"></el-table-column>
      
      <el-table-column prop="rid" label="用户RID" align="center" width="100"></el-table-column>
      
      <el-table-column prop="name" label="用户名称" align="center" width="120"></el-table-column>
      
      <el-table-column prop="giftName" label="礼物名称" align="center" width="120"></el-table-column>
      
      <el-table-column prop="giftIcon" label="礼物图标" align="center" width="120">
        <template slot-scope="scope">
          <media-preview :media-url="scope.row.giftIcon" />
        </template>
      </el-table-column>
      
      <el-table-column prop="reviewStatus" label="审核状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.reviewStatus)">
            {{ getStatusText(scope.row.reviewStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="statusReason" label="状态原因" align="center" width="150" show-overflow-tooltip></el-table-column>
      
      <el-table-column prop="applyTime" label="申请时间" align="center" width="160">
        <template slot-scope="scope">
          {{ formatDate(scope.row.applyTime) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="ctime" label="创建时间" align="center" width="160">
        <template slot-scope="scope">
          {{ formatDate(scope.row.ctime) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="operator" label="操作人" align="center" width="100"></el-table-column>
      
      <el-table-column label="操作" align="center" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button 
            v-if="scope.row.reviewStatus === 0 || scope.row.reviewStatus === 4"
            type="success" 
            size="mini" 
            @click="handleReview(scope.row, 1)">
            通过
          </el-button>
          <el-button 
            v-if="scope.row.reviewStatus === 0 || scope.row.reviewStatus === 4"
            type="danger" 
            size="mini" 
            @click="handleReview(scope.row, 2)">
            拒绝
          </el-button>
          <el-button 
            v-if="scope.row.reviewStatus === 1"
            type="warning" 
            size="mini" 
            @click="handleReview(scope.row, 3)">
            下架
          </el-button>
          <el-button 
            type="info" 
            size="mini" 
            @click="viewReviewLog(scope.row)">
            查看审核记录
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      :current-page.sync="queryParams.page"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="queryList"
      class="pagination">
    </el-pagination>

    <!-- 审核对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="reviewDialogVisible" width="500px">
      <el-form :model="reviewForm" label-width="120px">
        <el-form-item label="审核状态:">
          <el-select v-model="reviewForm.reviewStatus" style="width: 100%">
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核失败" :value="2"></el-option>
            <el-option label="已删除（已下架）" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态变更原因:" v-if="reviewForm.reviewStatus === 2">
          <el-input 
            v-model="reviewForm.statusReason" 
            type="textarea" 
            :rows="3"
            placeholder="请输入拒绝原因">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReview" :loading="reviewLoading">确认</el-button>
      </div>
    </el-dialog>

    <!-- 批量审核对话框 -->
    <el-dialog title="批量审核" :visible.sync="batchReviewDialogVisible" width="500px">
      <el-form :model="batchReviewForm" label-width="120px">
        <el-form-item label="审核状态:">
          <el-select v-model="batchReviewForm.reviewStatus" style="width: 100%">
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核失败" :value="2"></el-option>
            <el-option label="已删除（已下架）" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态变更原因:" v-if="batchReviewForm.reviewStatus === 2">
          <el-input 
            v-model="batchReviewForm.statusReason" 
            type="textarea" 
            :rows="3"
            placeholder="请输入拒绝原因">
          </el-input>
        </el-form-item>
        <el-form-item label="选中数量:">
          <span>{{ selectedRows.length }} 条记录</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchReviewDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmBatchReview" :loading="batchReviewLoading">确认</el-button>
      </div>
    </el-dialog>

    <!-- 审核记录对话框 -->
    <el-dialog title="审核记录" :visible.sync="reviewLogDialogVisible" width="80%" :before-close="handleReviewLogClose">
      <div v-loading="reviewLogLoading">
        <el-table :data="reviewLogData" border style="width: 100%">
          <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
          <el-table-column prop="uid" label="用户UID" align="center" width="120"></el-table-column>
          <el-table-column prop="rid" label="用户RID" align="center" width="100"></el-table-column>
          <el-table-column prop="name" label="用户名称" align="center" width="120"></el-table-column>
          <el-table-column prop="giftName" label="礼物名称" align="center" width="120"></el-table-column>
          <el-table-column prop="giftIcon" label="礼物图标" align="center" width="120">
            <template slot-scope="scope">
              <media-preview :media-url="scope.row.giftIcon" />
            </template>
          </el-table-column>
          <el-table-column prop="reviewStatus" label="审核状态" align="center" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.reviewStatus)">
                {{ getStatusText(scope.row.reviewStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="statusReason" label="状态原因" align="center" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statusReason">{{ scope.row.statusReason }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="giftId" label="绑定礼物ID" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.giftId">{{ scope.row.giftId }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间" align="center" width="160">
            <template slot-scope="scope">
              {{ formatDate(scope.row.applyTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="记录创建时间" align="center" width="160">
            <template slot-scope="scope">
              {{ formatDate(scope.row.ctime) }}
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.operator">{{ scope.row.operator }}</span>
              <span v-else class="text-muted">系统</span>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 审核记录分页 -->
        <el-pagination
          :current-page.sync="reviewLogParams.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="reviewLogTotal"
          @current-change="queryReviewLog"
          class="pagination">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewLogDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import MediaPreview from './MediaPreview.vue'

export default {
  name: 'CustomizedGiftReview',
  components: {
    MediaPreview
  },
  data() {
    return {
      loading: false,
      reviewLoading: false,
      batchReviewLoading: false,
      tableData: [],
      total: 0,
      selectedRows: [],
      dateRange: null,
      
      queryParams: {
        rid: '',
        reviewStatus: null,
        startTime: null,
        endTime: null,
        page: 1
      },
      
      reviewStatusOptions: [
        { label: '全部', value: null }
      ],
      
      reviewDialogVisible: false,
      batchReviewDialogVisible: false,
      dialogTitle: '',
      currentRow: null,
      
      reviewForm: {
        id: null,
        uid: '',
        reviewStatus: 1,
        statusReason: '',
        operator: ''
      },
      
      batchReviewForm: {
        reviewStatus: 1,
        statusReason: '',
        operator: ''
      },
      
      // 审核记录相关
      reviewLogDialogVisible: false,
      reviewLogLoading: false,
      reviewLogData: [],
      reviewLogTotal: 0,
      reviewLogParams: {
        uid: '',
        page: 1
      }
    }
  },
  
  created() {
    this.getReviewStatusOptions()
    this.queryList()
  },
  
  methods: {
    // 获取审核状态选项
    async getReviewStatusOptions() {
      try {
        const { data: res } = await this.$axios({
          method: 'GET',
          url: this.$store.getters.path.const_all,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            className: 'com.quhong.constant.activity.gift.customized.ReviewStatusConstant'
          }
        })
        
        if (res.code === 0 && res.data) {
          // 添加"全部"选项到开头
          this.reviewStatusOptions = [
            { label: '全部', value: null },
            ...res.data.map(item => ({
              label: item.name,
              value: item.value
            }))
          ]
        } else {
          console.warn('获取审核状态常量失败:', res.msg)
        }
      } catch (error) {
        console.error('获取审核状态常量失败:', error)
      }
    },
    
    // 查询列表
    async queryList() {
      this.loading = true
      try {
        const { data: res } = await this.$axios({
          method: 'GET',
          url: this.$store.getters.path.config_gift_customized_review_list,
          params: {
            ...this.queryParams,
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        
        if (res.code === 0) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请重试')
        console.error('查询定制礼物审核列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    // 日期范围改变
    onDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryParams.startTime = Math.floor(dateRange[0] / 1000)
        this.queryParams.endTime = Math.floor(dateRange[1] / 1000)
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
    },
    
    // 处理选择改变
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    
    // 单个审核
    handleReview(row, status) {
      this.currentRow = row
      this.reviewForm = {
        id: row.id,
        uid: row.uid,
        reviewStatus: status,
        statusReason: '',
        operator: this.$store.getters.username
      }
      
      this.dialogTitle = status === 1 ? '审核通过' : status === 2 ? '审核拒绝' : '下架礼物'
      this.reviewDialogVisible = true
    },
    
    // 确认审核
    async confirmReview() {
      if (this.reviewForm.reviewStatus === 2 && !this.reviewForm.statusReason.trim()) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      
      this.reviewLoading = true
      try {
        const { data: res } = await this.$axios({
          method: 'POST',
          url: this.$store.getters.path.config_gift_customized_review_review,
          data: this.reviewForm,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        
        if (res.code === 0) {
          this.$message.success('审核成功')
          this.reviewDialogVisible = false
          this.queryList()
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请重试')
        console.error('审核失败:', error)
      } finally {
        this.reviewLoading = false
      }
    },
    
    // 批量审核
    batchReview() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要审核的记录')
        return
      }
      
      this.batchReviewForm = {
        reviewStatus: 1,
        statusReason: '',
        operator: this.$store.getters.username
      }
      this.batchReviewDialogVisible = true
    },
    
    // 确认批量审核
    async confirmBatchReview() {
      if (this.batchReviewForm.reviewStatus === 2 && !this.batchReviewForm.statusReason.trim()) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      
      const reviewList = this.selectedRows.map(row => ({
        id: row.id,
        uid: row.uid,
        reviewStatus: this.batchReviewForm.reviewStatus,
        statusReason: this.batchReviewForm.statusReason,
        operator: this.batchReviewForm.operator
      }))
      
      this.batchReviewLoading = true
      try {
        const { data: res } = await this.$axios({
          method: 'POST',
          url: this.$store.getters.path.config_gift_customized_review_batch_review,
          data: { reviewList },
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        
        if (res.code === 0) {
          this.$message.success('批量审核成功')
          this.batchReviewDialogVisible = false
          this.queryList()
        } else {
          this.$message.error(res.msg || '批量审核失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请重试')
        console.error('批量审核失败:', error)
      } finally {
        this.batchReviewLoading = false
      }
    },
    
    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',  // 审核中
        1: 'success',  // 审核通过
        2: 'danger',   // 审核失败
        3: 'info',     // 已删除（已下架）
        4: 'warning'   // 审核中（替换）
      }
      return typeMap[status] || 'info'
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusOption = this.reviewStatusOptions.find(option => option.value === status)
      return statusOption ? statusOption.label : '未知'
    },
    
    // 查看审核记录
    async viewReviewLog(row) {
      this.reviewLogParams.uid = row.uid
      this.reviewLogParams.page = 1
      this.reviewLogDialogVisible = true
      await this.queryReviewLog()
    },
    
    // 查询审核记录
    async queryReviewLog() {
      this.reviewLogLoading = true
      try {
        const { data: res } = await this.$axios({
          method: 'GET',
          url: this.$store.getters.path.config_gift_customized_review_log_list,
          params: {
            ...this.reviewLogParams,
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        
        if (res.code === 0) {
          this.reviewLogData = res.data.data || []
          this.reviewLogTotal = res.data.total || 0
        } else {
          this.$message.error(res.msg || '查询审核记录失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请重试')
        console.error('查询审核记录失败:', error)
      } finally {
        this.reviewLogLoading = false
      }
    },
    
    // 关闭审核记录对话框
    handleReviewLogClose() {
      this.reviewLogDialogVisible = false
      this.reviewLogData = []
      this.reviewLogTotal = 0
      this.reviewLogParams.uid = ''
      this.reviewLogParams.page = 1
    },
    
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style lang="scss" scoped>
.customized-gift-review {
  margin: 20px;
  
  h2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .user-options {
    margin-bottom: 20px;
    
    > * {
      margin: 5px;
    }
  }
  
  .pagination {
    margin-top: 20px;
    text-align: center;
  }
  
  .text-muted {
    color: #999;
  }
}
</style>
